interface InitArgs {
  /** Extra key/value pairs to add as error attributes and tags. */
  context?: Record<string, unknown>;
  /** Optional error fingerprint for grouping similar errors together. */
  fingerprint?: string;
  message: string;
  originalError?: unknown;
}

export class BloomError extends Error {
  dd_context: Record<string, unknown>;
  dd_fingerprint?: string;
  originalError: Error;

  constructor({ context = {}, fingerprint, message, originalError }: InitArgs) {
    super(message);
    this.name = 'BloomError';

    this.originalError =
      originalError instanceof Error ? originalError : Error();
    this.stack = this.originalError?.stack;
    this.cause = this.originalError?.cause;

    /**
     * Automatically adds context for RUM errors.
     * @see https://docs.datadoghq.com/real_user_monitoring/browser/advanced_configuration/?tab=npm#attaching-local-error-context-with-dd_context
     */
    this.dd_context = context;
    this.dd_fingerprint = fingerprint;
  }
}
